import {
  BulkUpdateInspectionRequest,
  BulkUpdateInspectionRequestToJSON,
  CreateInspectionRequest,
  CreateInspectionRequestToJSON,
  DeleteInspectionRequest,
  DeleteInspectionToJSON,
  GetInspectionCountRequest,
  GetInspectionCountRequestToJSON,
  GetInspectionListRequest,
  GetInspectionListRequestToJSON,
  HTTPBody,
  HTTPQuery,
  Inspection,
  InspectionCheckedCount,
  InspectionCheckedCountFromJSON,
  InspectionFromJSON,
  InspectionList,
  InspectionListFromJSON,
  InspectionOfflineCheckJobRequest,
  InspectionOfflineCheckJobRequestToJSON,
  InspectionOfflineCheckTest,
  InspectionOfflineCheckTestFromJSON,
  InspectionOfflineCheckTestRequest,
  InspectionOfflineCheckTestRequestToJSON,
  ProcessInspection,
  ProcessInspectionFromJSON,
  ProcessInspectionRequest,
  ProcessInspectionRequestToJSON,
  UpdateInspectionRequest,
  UpdateInspectionRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class InspectionApi extends runtime.BaseAPI {
  /**
   * 蔵書点検対象一覧を取得する
   * 蔵書点検対象一覧取得
   */
  async getInspections(): Promise<Inspection[]> {
    const response = await this.requestGet('/inspections')

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(InspectionFromJSON)
    ).value()
  }

  /**
   * 蔵書点検対象を取得する
   * 蔵書点検対象取得
   */
  async getInspection(id: number): Promise<Inspection> {
    const response = await this.requestGet(`/inspections/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      InspectionFromJSON(jsonValue)
    ).value()
  }

  /**
   * 蔵書点検対象一覧を削除する
   * 蔵書点検対象一覧削除
   */
  async deleteInspection(
    request: DeleteInspectionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteInspectionToJSON(request)

    const response = await this.requestDelete(
      `/inspections/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 蔵書点検対象件数を取得する
   * 蔵書点検対象件数取得
   */
  async getInspectionCount(
    request: GetInspectionCountRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = GetInspectionCountRequestToJSON(request)

    const response = await this.requestPost(
      '/inspections/check-target-count',
      bodyParameters
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.count
    ).value()
  }

  /**
   * 蔵書点検対象を作成する
   * 蔵書点検対象作成
   */
  async createInspection(
    request: CreateInspectionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = CreateInspectionRequestToJSON(request)

    const response = await this.requestPost('/inspections', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 蔵書点検対象を更新する
   * 蔵書点検対象更新
   */
  async updateInspection(
    request: UpdateInspectionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateInspectionRequestToJSON(request)

    const response = await this.requestPut(
      `/inspections/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 蔵書点検対象を一括更新する
   * 蔵書点検対象一括更新
   */
  async bulkUpdateInspection(
    request: BulkUpdateInspectionRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = BulkUpdateInspectionRequestToJSON(request)

    const response = await this.requestPut(
      `/inspections/${request.id}/bulk-update`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  /**
   * 蔵書点検完了件数を取得する
   * 蔵書点検完了件数取得
   */
  async getInspectionCheckedCount(id: number): Promise<InspectionCheckedCount> {
    const response = await this.requestGet(`/inspections/${id}/checked-count`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      InspectionCheckedCountFromJSON(jsonValue)
    ).value()
  }

  /**
   * 蔵書点検を処理する
   * 蔵書点検処理
   */
  async processInspection(
    request: ProcessInspectionRequest
  ): Promise<ProcessInspection> {
    const bodyParameters: HTTPBody = ProcessInspectionRequestToJSON(request)

    const response = await this.requestPost(
      '/inspections/check',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ProcessInspectionFromJSON(jsonValue)
    ).value()
  }

  /**
   * 蔵書点検対象リストを取得する
   * 蔵書点検対象リスト取得
   */
  async getInspectionList(
    request: GetInspectionListRequest
  ): Promise<InspectionList> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(GetInspectionListRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(
      `/inspections/${request.id}/list`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      InspectionListFromJSON(jsonValue)
    ).value()
  }

  /**
   * オフライン蔵書点検テスト
   */
  async inspectionOfflineCheckTest(
    request: InspectionOfflineCheckTestRequest
  ): Promise<InspectionOfflineCheckTest> {
    const bodyParameters: HTTPBody = InspectionOfflineCheckTestRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/inspections/offline-check-test',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      InspectionOfflineCheckTestFromJSON(jsonValue)
    ).value()
  }

  /**
   * オフライン蔵書点検テスト
   */
  async inspectionOfflineCheckJob(
    request: InspectionOfflineCheckJobRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = InspectionOfflineCheckJobRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/inspections/offline-check',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
